// What the recipient's phone shows for the notification being edited:
// sender name on top, the text with sample values.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { smsLength } from './api';

const SmsPreview = ({ sender, eventLabel, text, enabled }) => {
    const { t } = useTranslation();
    const { chars, parts, unicode } = smsLength(text);
    return (
        <figure className="csms-phone" aria-label={t('customerSms.preview.label', 'Aperçu du SMS')}>
            <div className="csms-phone-screen">
                <div className="csms-phone-top">
                    <span className="csms-phone-avatar" aria-hidden="true">{(sender || '?').slice(0, 1).toUpperCase()}</span>
                    <strong className="csms-phone-sender">{sender}</strong>
                </div>
                <div className="csms-phone-thread">
                    <span className="csms-phone-time">{t('customerSms.preview.now', "Aujourd'hui")}</span>
                    <p className="csms-phone-bubble">{text}</p>
                </div>
            </div>
            <figcaption className="csms-phone-caption">
                <strong>{eventLabel}</strong>
                {!enabled && <span className="csms-chip csms-chip--muted">{t('customerSms.preview.off', 'désactivée')}</span>}
                <small>
                    {t('customerSms.events.length', '{{chars}} caractères · {{parts}} SMS', { chars, parts })}
                    {unicode ? ` · ${t('customerSms.preview.unicode', 'Unicode')}` : ''}
                </small>
                <small>{t('customerSms.preview.samples', "Valeurs d'exemple ; le vrai SMS reprend celles du colis.")}</small>
            </figcaption>
        </figure>
    );
};

export default SmsPreview;
